import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  NgModule,
  NgZone,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { interval, map } from 'rxjs';
import { isScullyRunning } from '@scullyio/ng-lib';
import { DateTime } from 'luxon';

@Component({
  selector: 'sh-ui-vertical-infos',
  template: `
    <ng-container *transloco="let t">
      <aside class="left">
        <div>
          <p [innerHTML]="t('layout.vertical-infos.left.label')"></p>
        </div>
      </aside>
      <aside class="right">
        <div>
          <p #timeComponent></p>
        </div>
      </aside>
    </ng-container>
  `,
  styleUrls: ['./vertical-infos.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerticalInfosComponent implements AfterViewInit {
  @ViewChild('timeComponent') timeComponent!: ElementRef<HTMLParagraphElement>;

  constructor(
    private translocoService: TranslocoService,
    private zone: NgZone
  ) {}

  ngAfterViewInit(): void {
    if (!isScullyRunning()) {
      this.zone.runOutsideAngular(() => {
        interval(1000)
          .pipe(
            map(() => {
              const date: string = new Intl.DateTimeFormat(
                this.translocoService.getActiveLang(),
                {
                  day: '2-digit',
                  weekday: 'short',
                  month: 'short',
                  year: 'numeric',
                }
              ).format(new Date());
              const time: string = DateTime.now().toFormat('HH:mm:ss');
              if (this.timeComponent) {
                this.timeComponent.nativeElement.innerText = `${date} - ${time}`;
              }
            })
          )
          .subscribe();
      });
    }
  }
}

@NgModule({
  imports: [CommonModule, TranslocoModule],
  declarations: [VerticalInfosComponent],
  exports: [VerticalInfosComponent],
})
export class VerticalInfosComponentModule {}
